import CopyToClipboard from 'react-copy-to-clipboard'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Popover } from 'antd'

import Button from '~/core/Button'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'

type CopyLinkPopoverPropsType = {
    placement: string
    togglePopover?: (visible: boolean) => void
    quoteURL: string
    onCopied: (text: string, result: boolean) => void
    visible?: boolean
    children?: JSX.Element
    isObo: boolean
}

const CopyLinkPopover = (props: CopyLinkPopoverPropsType) => {
    const {
        placement,
        togglePopover,
        quoteURL,
        onCopied,
        visible,
        children,
        isObo,
    } = props

    const PopoverContent = (
        <Box style={{ maxWidth: '300px', padding: '4px' }} direction="col">
            <Box direction="row">
                <ExclamationCircleFilled
                    style={{
                        color: getColor('warning'),
                        paddingRight: '11px',
                        paddingTop: '2px',
                    }}
                />
                {isObo ? (
                    <p>
                        <b>Admin Warning:</b> Due to potential security risks,
                        sharing this URL will only work for users with existing
                        quote access. To invite a new user, you must share with
                        their email above.
                    </p>
                ) : (
                    <p>
                        <b>Warning:</b> Anyone with access to this link can be
                        added to this quote as a collaborator with the ability
                        to edit and access quote content, including your Part
                        Drawings and/or Specifications.
                    </p>
                )}
            </Box>
            <Box direction="row" display="flex" justifyContent="end">
                <Button
                    placement={placement}
                    size="small"
                    name="cancel-copy-link"
                    data-test-target="cancel-copy-open-invite-link"
                    onClick={togglePopover}
                    style={{ marginRight: '4px' }}
                >
                    Cancel
                </Button>
                <CopyToClipboard text={quoteURL} onCopy={onCopied}>
                    <Button
                        size="small"
                        placement={placement}
                        name="copy-link"
                        data-test-target="copy-open-invite-link"
                        type="primary"
                        onClick={togglePopover}
                    >
                        Copy anyway
                    </Button>
                </CopyToClipboard>
            </Box>
        </Box>
    )

    if (!children) {
        return null
    }

    return (
        <Popover
            visible={visible}
            onVisibleChange={togglePopover}
            content={PopoverContent}
            trigger="click"
        >
            {children}
        </Popover>
    )
}

export default CopyLinkPopover
